import { useGetter } from 'vuex-react'
import { useEffect } from 'react'

export const AppMenu = ({ onPageChange, currentPage }) => {
  const menuItems = [
    { name: 'Encrypt', page: 'encrypt' },
    { name: 'Decrypt', page: 'decrypt' },
    { name: 'Config', page: 'settings' }
  ]

  const [isOnline, setIsOnline] = useGetter('network/isOnline');
  const [encryptionConfig] = useGetter('encryptionConfig/config');

  useEffect(() => {
    const onlineListener = window.addEventListener('online', () => setIsOnline(true)),
          offlineListener = window.addEventListener('offline', () => setIsOnline(false));
  
    return () => {
      window.removeEventListener('online', onlineListener);
      window.removeEventListener('offline', offlineListener);
    }
  }, [setIsOnline]);

  return (
    <div className="app-menu">
      <h1>Cypcator</h1>
      <p className="online-text">
        {encryptionConfig.join('/')}
        {" | " + (isOnline ? "ONLINE" : "OFFLINE")}
      </p>

      <nav id="menu">
        <ul>
          {menuItems.map(item => (
            <li
              key={item.page}
              onClick={() => onPageChange(item.page)}
              className={currentPage === item.page ? 'active' : ''}
            >
              {item.name}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}
